import React, { useRef, useState, useEffect, LegacyRef, MutableRefObject } from 'react'
import { useForm, Controller, useController } from "react-hook-form";
import type { FieldErrors, Control, UseFormSetValue } from "react-hook-form";

import Error from "@/components/Form/Error"
import JSONEditor, { JSONEditorMode } from 'jsoneditor';
import 'jsoneditor/dist/jsoneditor.css';

type JSONFieldProps = {
	control: any
	setValue?: any
	errors?: FieldErrors
	name: string
	defaultValue?: string
}

const JSONField = ({
	control,
	setValue,
	errors,
	name,
	defaultValue
}: JSONFieldProps) => {
	const jsonRef = useRef<HTMLElement | undefined>(null)
	const { field, fieldState } = useController({ name, control })
	const editorRef = useRef<JSONEditor>(null)

	useEffect(() => {
		const EditorContainer = new JSONEditor(jsonRef.current as HTMLElement, {
			name: name,
      modes: ['tree', 'form', 'code'],
			onChange: () => {
				field.onChange(EditorContainer.get())
			}
		}, field.value)

		editorRef.current = EditorContainer as JSONEditor

		return () => {
			EditorContainer.destroy()
		}
	}, [defaultValue])

	useEffect(() => {
    if (!fieldState.isDirty) {
      editorRef.current?.set(field.value)
    } else {
      editorRef.current?.update(field.value)
    }
  }, [field.value])

	return (
		<>
			<div ref={jsonRef as LegacyRef<HTMLDivElement> | undefined} className="json-editor" />
			<Error name={name} errors={errors}/>
			<br/>
		</>
	)
}
export default JSONField